import React from 'react';
import PropTypes from 'prop-types';
import clone from 'clone';
import FileSaver from 'file-saver';

import {withIsOpenState} from '../../../lib/react/higher-order-components';
import retardUpdate from '../../../lib/react/update-retarder';
import {oeInterfaceManager} from '../../../react-oe/oe-interface';
import OEInterfaceAdapter from '../../../react-oe/oe-interface-adapter';
import OEIconCodes from '../../../lib/oe-icon-codes';
import {OEGroupControl, OEControl, OEIconButtonControl, OECheckboxControl, OETextFieldControl} from '../../elements/controls/oe-controls';
import {OECustomCheckboxManaged} from '../../elements/controls/oe-checkbox';
import OEDropdown from '../../elements/controls/oe-dropdown';
import {OEMediaCenterItemFlags} from '../media-center/oe-media-center-model';
import {OEPresentationViewFlags, OEPresentationFlags, OEPresentationPlayableFlags, OEPresentationNoteStateModResultType} from './oe-presentation-model';
import OEPopover from '../../views/oe-popover';
import {OEModalStyle} from '../../modals/oe-modal';
import {OEPresentationPresetPopover} from './oe-presentation-preset-controller';
import {OENoteTextIDBits} from '../notes/oe-note-model';

export class OEPresentationDataController extends React.PureComponent {

    constructor(props)  {
        super(props);

        this.oe = oeInterfaceManager.getInterface(this.props.moduleId);

        this.endAnimationModeEntries = [{key: 0, label: ''}, {key: 1, label: ''}, {key: 2, label: ''}, {key: 3, label: ''}];

        this.state = {
            uiEnabled:                                  false,
            data:                                       null,
            strings: {
                allowVPGizmo:                           '',
                resetComponentColors:                   '',
                viewFlagsLabel:                         '',
                viewFlagsEditorLabel:                   '',
                viewFlagsMediaCenterLabel:              '',
                flagsLabel:                             '',
                flagsNoSliderLabel:                     '',
                flagsAnimatePrevSlideTransitionsLabel:  '',
                flagsDisableStateTracking:              '',
                flagsNoPreviewSlidesLabel:              '',
                flagsNoBackForthLabel:                  '',
                playableFlagsLabel:                     '',
                hasPlayableFlagsLabel:                  '',
                playableFlagsMultipleSlidesLabel:       '',
                playableFlagsAudioLabel:                '',
                playableFlagsAnimatableAttributeLabel:  '',
                playableFlagsAnimatableSlideAttributeLabel: '',
                endAnimationModeLabel:                  '',
                userRef:                                '',
                applyPresets:                           '',
                saveNoteModifier:                       '',
                applyNoteModifier:                      ''
            },
            endAnimationModeEntries:                    clone(this.endAnimationModeEntries),
            playableFlags:                              0,
            isPresentationPresetOpen:                   false
        };

        this.updateLanguage = this.updateLanguage.bind(this);
        this.onPresentationDataChanged = this.onPresentationDataChanged.bind(this);
        this.onUIControllerStateChanged = this.onUIControllerStateChanged.bind(this);

        this.onApplyNoteModifierFileLoadInputRef = this.onApplyNoteModifierFileLoadInputRef.bind(this);

        this.onAllowVPGizmoChanged = this.onAllowVPGizmoChanged.bind(this);
        //this.onComponentColorsResetBtnPressed = this.onComponentColorsResetBtnPressed.bind(this);
        this.onViewFlagsChanged = this.onViewFlagsChanged.bind(this);
        this.onFlagsChanged = this.onFlagsChanged.bind(this);
        this.onPlayableFlagsChanged = this.onPlayableFlagsChanged.bind(this);
        this.onEndAnimationModeSelected = this.onEndAnimationModeSelected.bind(this);
        this.onUserRefChanged = this.onUserRefChanged.bind(this);
        this.onApplyPresetsBtnPressed = this.onApplyPresetsBtnPressed.bind(this);
        this.onSaveNoteModifierBtnPressed = this.onSaveNoteModifierBtnPressed.bind(this);
        this.onApplyNoteModifierBtnPressed = this.onApplyNoteModifierBtnPressed.bind(this);
        this.onApplyNoteModifierFileLoadInputResult = this.onApplyNoteModifierFileLoadInputResult.bind(this);
        this.onPresentationPresetPopoverToggle = this.onPresentationPresetPopoverToggle.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.id != this.props.id)   {
            this.updatePresentationData(undefined, nextProps);
        }
    }

    onConnect()  {
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.languageChanged, this.updateLanguage);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.presentationDataChanged, this.onPresentationDataChanged);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.uiControllerStateChanged, this.onUIControllerStateChanged);
    }

    onRelease()    {
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.languageChanged, this.updateLanguage);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.presentationDataChanged, this.onPresentationDataChanged);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.uiControllerStateChanged, this.onUIControllerStateChanged);
    }

    updateLanguage()   {
        let si = this.oe.sharedInterface;

        this.endAnimationModeEntries[0].label = '';
        this.endAnimationModeEntries[1].label = si.getLocalizedStringEnc('end_animation_mode_stop');
        this.endAnimationModeEntries[2].label = si.getLocalizedStringEnc('end_animation_mode_repeat');
        this.endAnimationModeEntries[3].label = si.getLocalizedStringEnc('end_animation_mode_stay_at_end');

        this.setState({
            strings: {
                allowVPGizmo:                               si.getLocalizedStringEnc('pres_allow_vp_gizmo'),
                resetComponentColors:                       si.getLocalizedStringEnc('pres_slide_component_colors_reset'),
                viewFlagsLabel:                             si.getLocalizedStringEnc('pres_view_flags'),
                viewFlagsEditorLabel:                       si.getLocalizedStringEnc('pres_view_flags_editor'),
                viewFlagsMediaCenterLabel:                  si.getLocalizedStringEnc('pres_view_flags_media_center'),
                flagsLabel:                                 si.getLocalizedStringEnc('pres_flags'),
                flagsNoSliderLabel:                         si.getLocalizedStringEnc('pres_flags_no_slider'),
                flagsAnimatePrevSlideTransitionsLabel:      si.getLocalizedStringEnc('pres_flags_animate_prev_slide_transitions'),
                flagsDisableStateTracking:                  si.getLocalizedStringEnc('pres_flags_disable_state_tracking'),
                flagsNoPreviewSlidesLabel:                  si.getLocalizedStringEnc('pres_flags_no_preview_slides'),
                flagsNoBackForthLabel:                      si.getLocalizedStringEnc('pres_flags_no_back_forth'),
                playableFlagsLabel:                         si.getLocalizedStringEnc('pres_playable_flags'),
                hasPlayableFlagsLabel:                      si.getLocalizedStringEnc('pres_has_playable_flags'),
                playableFlagsMultipleSlidesLabel:           si.getLocalizedStringEnc('pres_playable_flags_multiple_slides'),
                playableFlagsAudioLabel:                    si.getLocalizedStringEnc('pres_playable_flags_audio'),
                playableFlagsAnimatableAttributeLabel:      si.getLocalizedStringEnc('pres_playable_flags_animatable_attribute'),
                playableFlagsAnimatableSlideAttributeLabel: si.getLocalizedStringEnc('pres_playable_flags_animatable_slide_attribute'),
                endAnimationModeLabel:                      si.getLocalizedStringEnc('pres_end_animation_mode'),
                userRef:                                    si.getLocalizedStringEnc('pres_user_ref'),
                applyPresets:                               si.getLocalizedStringEnc('pres_apply_presets'),
                saveNoteModifier:                           si.getLocalizedStringEnc('pres_save_note_modifier'),
                applyNoteModifier:                          si.getLocalizedStringEnc('pres_apply_note_modifier')
            },
            endAnimationModeEntries:                        clone(this.endAnimationModeEntries)
        });
    }

    updatePresentationData(data, props)   {
        data = data || null;
        props = props || this.props;
        if(this.oe.isReady() && !data && props.id >= 0)  {
            let pres = this.oe.sharedInterface.getUIControllerPresentation();
            data = pres.getPresentationDataID(props.id)
        }
        this.setState({data: data});

        if(data && typeof(data.playableFlags) === 'number') {
            this.setState({playableFlags: data.playableFlags});
        }
    }

    updateUIState()   {
        this.setState({
            uiEnabled: this.oe.sharedInterface.getUIControllerPresentation().getUIEnabled()
        });
    }

    updateState(released)   {
        if(!this.oe.isReady() || released === true)   {
            this.setState({
                uiEnabled:                  false,
                data:                       null,
                isPresentationPresetOpen:   false
            });
            return;
        }

        retardUpdate(this, () => {
            this.updateLanguage();
            this.updatePresentationData();
            this.updateUIState();
        });
    }

    onPresentationDataChanged(message, userInfo)    {
        if(this.props.id < 0 || this.props.id != userInfo.presID) return;
        this.updatePresentationData(userInfo.presData);
    }

    onUIControllerStateChanged(message, userInfo)    {
        if(userInfo.type === this.oe.Module.UIControllerType.presentation) {
            this.updateUIState();
        }
    }

    onApplyNoteModifierFileLoadInputRef(ref)    {
        this.applyNoteModifierFileLoadInput = ref;
    }

    render()    {
        const disabled = !this.state.uiEnabled || this.props.id < 0 || !this.state.data;

        let viewFlags = this.state.data ? this.state.data.viewFlags : 0;
        let flags = this.state.data ? this.state.data.flags : 0;

        let hasPlayableFlags = this.state.data && typeof(this.state.data.playableFlags) === 'number';
        let playableFlags = hasPlayableFlags ? this.state.data.playableFlags : this.state.playableFlags;

        let choosenEndAnimationModeKey = !this.state.data || !this.state.data.endAnimationMode ? 0 : Math.min(this.state.data.endAnimationMode.value + 1, 3);
        let endAnimationModeEntries = this.state.endAnimationModeEntries.map(e => { return {key: e.key, content: <span className="label">{e.label}</span>}; });

        return(
            <React.Fragment>
                <OEInterfaceAdapter moduleId={this.props.moduleId} receiver={this}/>

                <input
                    type="file"
                    accept=".xml"
                    ref={this.onApplyNoteModifierFileLoadInputRef}
                    style={{display: 'none'}}
                    onChange={this.onApplyNoteModifierFileLoadInputResult}
                />

                <div className="presentation-data-controller">
                    <OEGroupControl>
                        <OECheckboxControl
                            title={this.state.strings.allowVPGizmo}
                            checked={this.state.data ? !!(this.state.data.mcItemFlags & OEMediaCenterItemFlags.allowVPGizmo) : false}
                            disabled={disabled}
                            onPressed={this.onAllowVPGizmoChanged}
                        />
                        {/*!this.props.devFeatures ? null :
                            <OEIconButtonControl
                                title={this.state.strings.resetComponentColors}
                                disabled={disabled}
                                icon={OEIconCodes.pres.resetCompColors}
                                onPressed={this.onComponentColorsResetBtnPressed}
                            />
                        */}
                    </OEGroupControl>

                    {!this.props.devFeatures ? null :
                        <OEGroupControl className="compact" title={this.state.strings.flagsLabel}>
                            <OECheckboxControl
                                title={this.state.strings.flagsNoSliderLabel}
                                checked={!!(flags & OEPresentationFlags.noSlider)}
                                disabled={disabled}
                                onPressed={this.onFlagsChanged}
                                userData={OEPresentationFlags.noSlider}
                            />
                            <OECheckboxControl
                                title={this.state.strings.flagsAnimatePrevSlideTransitionsLabel}
                                checked={!!(flags & OEPresentationFlags.animatePrevSlideTransitions)}
                                disabled={disabled}
                                onPressed={this.onFlagsChanged}
                                userData={OEPresentationFlags.animatePrevSlideTransitions}
                            />
                            <OECheckboxControl
                                title={this.state.strings.flagsDisableStateTracking}
                                checked={!!(flags & OEPresentationFlags.disableStateTracking)}
                                disabled={disabled}
                                onPressed={this.onFlagsChanged}
                                userData={OEPresentationFlags.disableStateTracking}
                            />
                            <OECheckboxControl
                                title={this.state.strings.flagsNoPreviewSlidesLabel}
                                checked={!!(flags & OEPresentationFlags.noPreviewSlides)}
                                disabled={disabled}
                                onPressed={this.onFlagsChanged}
                                userData={OEPresentationFlags.noPreviewSlides}
                            />
                            <OECheckboxControl
                                title={this.state.strings.flagsNoBackForthLabel}
                                checked={!!(flags & OEPresentationFlags.noBackForth)}
                                disabled={disabled}
                                onPressed={this.onFlagsChanged}
                                userData={OEPresentationFlags.noBackForth}
                            />
                        </OEGroupControl>
                    }

                    {!this.props.devFeatures ? null :
                        <OEGroupControl title={this.state.strings.endAnimationModeLabel}>
                            <OEControl>
                                <OEDropdown
                                    title={this.state.endAnimationModeEntries[choosenEndAnimationModeKey].label}
                                    disabled={disabled}
                                    chosenKey={choosenEndAnimationModeKey}
                                    entries={endAnimationModeEntries}
                                    onClick={this.onEndAnimationModeSelected}
                                />
                            </OEControl>
                        </OEGroupControl>
                    }

                    {!this.props.devFeatures ? null :
                        <OEGroupControl className="compact" title={this.state.strings.playableFlagsLabel}>
                            <OECheckboxControl
                                title={this.state.strings.hasPlayableFlagsLabel}
                                checked={hasPlayableFlags}
                                disabled={disabled}
                                onPressed={this.onPlayableFlagsChanged}
                                userData={-1}
                            />
                            <OECheckboxControl
                                title={this.state.strings.playableFlagsMultipleSlidesLabel}
                                checked={!!(playableFlags & OEPresentationPlayableFlags.multipleSlides)}
                                disabled={disabled || !hasPlayableFlags}
                                onPressed={this.onPlayableFlagsChanged}
                                userData={OEPresentationPlayableFlags.multipleSlides}
                            />
                            <OECheckboxControl
                                title={this.state.strings.playableFlagsAudioLabel}
                                checked={!!(playableFlags & OEPresentationPlayableFlags.audio)}
                                disabled={disabled || !hasPlayableFlags}
                                onPressed={this.onPlayableFlagsChanged}
                                userData={OEPresentationPlayableFlags.audio}
                            />
                            <OECheckboxControl
                                title={this.state.strings.playableFlagsAnimatableAttributeLabel}
                                checked={!!(playableFlags & OEPresentationPlayableFlags.animatableAttribute)}
                                disabled={disabled || !hasPlayableFlags}
                                onPressed={this.onPlayableFlagsChanged}
                                userData={OEPresentationPlayableFlags.animatableAttribute}
                            />
                            <OECheckboxControl
                                title={this.state.strings.playableFlagsAnimatableSlideAttributeLabel}
                                checked={!!(playableFlags & OEPresentationPlayableFlags.animatableSlideAttribute)}
                                disabled={disabled || !hasPlayableFlags}
                                onPressed={this.onPlayableFlagsChanged}
                                userData={OEPresentationPlayableFlags.animatableSlideAttribute}
                            />
                        </OEGroupControl>
                    }

                    {!this.props.devFeatures ? null :
                        <OEGroupControl className="compact" title={this.state.strings.viewFlagsLabel}>
                            <OECheckboxControl
                                title={this.state.strings.viewFlagsEditorLabel}
                                checked={!!(viewFlags & OEPresentationViewFlags.editor)}
                                disabled={disabled}
                                onPressed={this.onViewFlagsChanged}
                                userData={OEPresentationViewFlags.editor}
                            />
                            <OECheckboxControl
                                title={this.state.strings.viewFlagsMediaCenterLabel}
                                checked={!!(viewFlags & OEPresentationViewFlags.mediaCenter)}
                                disabled={disabled}
                                onPressed={this.onViewFlagsChanged}
                                userData={OEPresentationViewFlags.mediaCenter}
                            />
                        </OEGroupControl>
                    }

                    {!this.props.devFeatures ? null :
                        <OEGroupControl>

                            <OETextFieldControl 
                                title={this.state.strings.userRef}
                                disabled={disabled}
                                clearButton={false}
                                value={this.state.data ? this.state.data.userRef : ''}
                                onChange={this.onUserRefChanged}
                            />

                            <OEIconButtonControl
                                title={this.state.strings.applyPresets}
                                disabled={disabled}
                                activated={this.state.isPresentationPresetOpen}
                                icon={OEIconCodes.pres.applyPresets}
                                onPressed={this.onApplyPresetsBtnPressed}
                            />
                            <OEIconButtonControl
                                title={this.state.strings.saveNoteModifier}
                                disabled={disabled}
                                icon={OEIconCodes.pres.saveNoteModifier}
                                onPressed={this.onSaveNoteModifierBtnPressed}
                            />
                            <OEIconButtonControl
                                title={this.state.strings.applyNoteModifier}
                                disabled={disabled}
                                icon={OEIconCodes.pres.applyNoteModifier}
                                onPressed={this.onApplyNoteModifierBtnPressed}
                            />
                        </OEGroupControl>
                    }

                </div>

                <OEPresentationPresetPopover
                    moduleId={this.props.moduleId}
                    appComponent={this.props.appComponent}
                    target={this.props.popoverTargetId}
                    boundariesElement={this.props.boundariesElement}
                    placement="right-start"
                    hideArrow={true}
                    id={this.props.id}
                    isOpen={this.state.isPresentationPresetOpen}
                    onToggle={this.onPresentationPresetPopoverToggle}
                />

            </React.Fragment>
        );
    }

    onAllowVPGizmoChanged()   {
        if(!this.oe.isReady() || this.props.id < 0 || !this.state.data)  return;
        if(this.state.data.mcItemFlags & OEMediaCenterItemFlags.allowVPGizmo)   {
            this.oe.sharedInterface.getUIControllerPresentation().removePresentationMCItemFlagsID(this.props.id, OEMediaCenterItemFlags.allowVPGizmo);
        } else {
            this.oe.sharedInterface.getUIControllerPresentation().addPresentationMCItemFlagsID(this.props.id, OEMediaCenterItemFlags.allowVPGizmo);
        }
    }

    /*
    onComponentColorsResetBtnPressed()  {
        if(!this.oe.isReady() || !this.props.ids)  return;
        let si = this.oe.sharedInterface;
        let pres = si.getUIControllerPresentation();

        let title = si.getLocalizedStringEnc('alert_pres_reset_component_colors_title'), msg = si.getLocalizedStringEnc('alert_pres_reset_component_colors_msg');

        let buttons = (id, container) => [{
                title: si.getLocalizedStringEnc('alert_pres_cancel_btn_message'),
                onClick: () => { container.closeModal(id) },
                className: 'btn-primary'
            },
            {
                title: si.getLocalizedStringEnc('alert_pres_reset_component_colors_only_hidden'),
                onClick: () => {
                    container.closeModal(id); 
                    pres.resetSlideComponentColorsID(this.props.ids.pres, this.props.ids.slide, true);
                    if(pres.getActivePresentationID() == this.props.ids.pres && pres.getActiveSlideID() == this.props.ids.slide)    pres.apply(true);
                },
                className: 'btn-primary'
            },
            {
                title: si.getLocalizedStringEnc('alert_pres_reset_component_colors_ok'),
                onClick: () => {
                    container.closeModal(id); 
                    pres.resetSlideComponentColorsID(this.props.ids.pres, this.props.ids.slide, false);
                    if(pres.getActivePresentationID() == this.props.ids.pres && pres.getActiveSlideID() == this.props.ids.slide)    pres.apply(true);
                },
                className: 'btn-primary'
            }
        ];

        this.props.appComponent.module.addModal(title, msg, buttons);
    }
    */

    onViewFlagsChanged(sender, userData)    {
        if(!this.oe.isReady() || this.props.id < 0 || !this.state.data) return;
        this.oe.sharedInterface.getUIControllerPresentation().setPresentationViewFlagsID(this.props.id, this.state.data.viewFlags ^ userData);
    }

    onFlagsChanged(sender, userData)    {
        if(!this.oe.isReady() || this.props.id < 0 || !this.state.data) return;
        this.oe.sharedInterface.getUIControllerPresentation().setPresentationFlagsID(this.props.id, this.state.data.flags ^ userData);
    }

    onPlayableFlagsChanged(sender, userData)    {
        if(!this.oe.isReady() || this.props.id < 0 || !this.state.data) return;
        if(userData === -1) {
            this.oe.sharedInterface.getUIControllerPresentation().setPresentationPlayableFlagsID(this.props.id, typeof(this.state.data.playableFlags) === 'number' ? undefined : this.state.playableFlags);
        } else if(typeof(this.state.data.playableFlags) === 'number') {
            this.oe.sharedInterface.getUIControllerPresentation().setPresentationPlayableFlagsID(this.props.id, this.state.data.playableFlags ^ userData);
        }
    }

    onEndAnimationModeSelected(key)  {
        if(!this.oe.isReady() || this.props.id < 0) return;
        this.oe.sharedInterface.getUIControllerPresentation().setPresentationEndAnimationModeID(this.props.id, key > 0 ? {value: key - 1} : undefined);
    }

    onUserRefChanged(sender, value)  {
        if(!this.oe.isReady() || this.props.id < 0) return;
        this.oe.sharedInterface.getUIControllerPresentation().setPresentationUserRefID(this.props.id, value);
    }

    onApplyPresetsBtnPressed()  {
        if((!this.oe.isReady() || this.props.id < 0) && !this.state.isPresentationPresetOpen) return;
        this.setState({isPresentationPresetOpen: !this.state.isPresentationPresetOpen});
    }

    showModal(title, content, isAlert = false)  {
        if(!this.props.appComponent)    return;

        let ok = this.oe.isReady() ? this.oe.sharedInterface.getLocalizedStringEnc('alert_ok') : 'OK';
        let buttons = (id, container) => [{title: ok, onClick: () => { container.closeModal(id) }, className: 'btn-primary'}];

        this.props.appComponent.module.addModal(title, content, buttons, !isAlert ? {style: OEModalStyle.message} : undefined);
    }

    onSaveNoteModifierBtnPressed()  {
        if(!this.oe.isReady() || this.props.id < 0) return;

        let appComponent = this.props.appComponent;
        const id = this.props.id;
        
        if(appComponent)    appComponent.showWaitingController();

        let pres = this.oe.sharedInterface.getUIControllerPresentation();
        pres.getNoteTextIDInfoForPresentationID(id, (result) => {
            let si = this.oe.sharedInterface;

            //
            if(result.result !== OEPresentationNoteStateModResultType.ok)   {
                let info = result.info ? result.info : 'Unexpected error.';
                console.log("Getting note text id info for presentation failed with: " + info);

                let localizedInfo = result.localizedInfo ? result.localizedInfo : info;

                if(appComponent)    appComponent.hideWaitingController();

                this.showModal(si.getLocalizedStringEnc('alert_error_title'), localizedInfo, true);
                return;
            }

            //
            if((result.textIDInfo.bits & OENoteTextIDBits.uniqueComplete) == OENoteTextIDBits.uniqueComplete)   {
                this.saveNoteModifier(id, (result) => {
                    if(appComponent)    appComponent.hideWaitingController();
                });
                return;
            }

            //
            let messageId = 'alert_pres_save_note_mod_msg_not_unique_complete';
            if(result.textIDInfo.bits & OENoteTextIDBits.uniqueComplete)    {
                if(!(result.textIDInfo.bits & OENoteTextIDBits.unique))     messageId = 'alert_pres_save_note_mod_msg_not_unique';
                if(!(result.textIDInfo.bits & OENoteTextIDBits.complete))   messageId = 'alert_pres_save_note_mod_msg_not_complete';
            }

            let message         = si.getLocalizedStringEnc(messageId);
            let uniqueOption    = si.getLocalizedStringEnc('alert_pres_save_note_mod_unique_option');
            let completeOption  = si.getLocalizedStringEnc('alert_pres_save_note_mod_complete_option');

            let options = {unique: false, complete: true};

            let content = function()    {
                // for some unknown reason react treats some parts of the content of <div className="status-dlg"> as an array and warns of missing keys
                // the only way to get rid of this is to assign some virtual needless keys

                return (
                    <div className="save-note-mod-dlg">

                        <span key="0" className="message">{message}</span>

                        <div key="1" className="options">
                            {result.textIDInfo.bits & OENoteTextIDBits.complete ? null :
                                <div key="2">
                                    <OECustomCheckboxManaged key="3" checked={options.complete} onPressed={(sender) => {
                                        options.complete = sender.checked;
                                    }}/>
                                    <span key="4">{completeOption}</span>
                                </div>
                            }

                            {result.textIDInfo.bits & OENoteTextIDBits.unique ? null :
                                <div key="5">
                                    <OECustomCheckboxManaged key="6" checked={options.unique} onPressed={(sender) => {
                                        options.unique = sender.checked;
                                    }}/>
                                    <span key="8">{uniqueOption}</span>
                                </div>
                            }
                        </div>

                    </div>
                );
            };

            let buttons = (modalId, container) => [
                {
                    title: si.getLocalizedStringEnc('alert_pres_save_note_mod_btn_save'),
                    onClick: () => { 
                        container.closeModal(modalId);

                        let bits = 0;
                        if(!(result.textIDInfo.bits & OENoteTextIDBits.unique) && options.unique)       bits = bits | OENoteTextIDBits.unique;
                        if(!(result.textIDInfo.bits & OENoteTextIDBits.complete) && options.complete)    bits = bits | OENoteTextIDBits.complete;

                        if(appComponent)    appComponent.showWaitingController();

                        this.saveNoteModifier(id, (result) => {
                            if(appComponent)    appComponent.hideWaitingController();
                        }, bits);

                    },
                    className: 'btn-primary'},
                {
                    title: si.getLocalizedStringEnc('alert_pres_save_note_mod_btn_cancel'),
                    onClick: () => { container.closeModal(modalId);},
                    className: 'btn-secondary'}
            ];

            if(appComponent)    {
                appComponent.hideWaitingController();
                appComponent.module.addModal(si.getLocalizedStringEnc('alert_pres_save_note_mod_title'), content, buttons, {style: OEModalStyle.message});
            }
        });
    }

    onApplyNoteModifierBtnPressed()  {
        if(!this.oe.isReady() || this.props.id < 0) return;

        if(!this.applyNoteModifierFileLoadInput) return;
        this.applyNoteModifierFileLoadInput.value = null;       // empties the file list so that onApplyNoteModifierFileLoadInputResult gets called when loading the same file multiple times successively
        this.applyNoteModifierFileLoadInput.click();
    }

    onApplyNoteModifierFileLoadInputResult(event)    {
        event.stopPropagation();
        event.preventDefault();

        const id = this.props.id;

        if(!this.oe.isReady() || id < 0) return;

        if(event.target.files.length == 0)  return;

        //
        let appComponent = this.props.appComponent;
        if(appComponent)    appComponent.showWaitingController();

        //
        let files = [event.target.files[0]];
        let allFileProgress = {i: 0, num: files.length};

        //
        let onLoadFunc = function(event)  {
            if(event.target.readyState != FileReader.DONE)  return;

            if(this.oe.isReady())    {
                let pres = this.oe.sharedInterface.getUIControllerPresentation();
                let arrayBuffer = event.target.result;

                pres.applyNoteStateModifiersToPresentationID(id, arrayBuffer, (result) => {
                    let si = this.oe.sharedInterface;

                    if(result.result === OEPresentationNoteStateModResultType.ok)  {

                        this.showModal(
                            si.getLocalizedStringEnc('alert_succeeded_title'),
                            si.getLocalizedStringEnc('alert_pres_apply_note_mod_msg_succeeded').replaceAll('#notes', result.count.toString()).replaceAll('#slides', result.slideCount.toString()),
                            false
                        );

                    } else {
                        let info = result.info ? result.info : 'Unexpected error.';
                        console.log("Applying presentation note modifiers failed with: " + info);

                        let localizedInfo = result.localizedInfo ? result.localizedInfo : info;

                        this.showModal(
                            si.getLocalizedStringEnc('alert_error_title'),
                            si.getLocalizedStringEnc('alert_pres_apply_note_mod_msg_error').replaceAll('#error', localizedInfo).replaceAll('#notes', result.count.toString()).replaceAll('#slides', result.slideCount.toString()),
                            true
                        );
                    }
                });
            }

            allFileProgress.i = allFileProgress.i + 1;
            if(allFileProgress.i == allFileProgress.num && appComponent)    appComponent.hideWaitingController();

         }.bind(this);

        //
        for(let i = 0; i < files.length; ++i)  {
            let reader = new FileReader();
            reader.onload = onLoadFunc;
            reader.readAsArrayBuffer(files[i]);
        }
    }

    onPresentationPresetPopoverToggle() {
        this.setState({isPresentationPresetOpen: false});
    }

    saveNoteModifier(id, callback, bits = 0)  {
        if(!this.oe.isReady() || id < 0)  {
            if(callback)    callback({result: OEPresentationNoteStateModResultType.unexpected, info: 'Not ready.', localizedInfo: '', infoId: '', count: 0, slideCount: 0});
            return;
        }

        //
        let pres = this.oe.sharedInterface.getUIControllerPresentation();

        pres.saveNoteStateModifiersForPresentationID(id, (result, buffer) => {
            if(result.result !== OEPresentationNoteStateModResultType.ok)    {
                let info = result.info ? result.info : 'Unexpected error.';
                console.log("Saving presentation note modifiers failed with: " + info);

                if(callback)    callback(result);
                return;
            }

            let name = 'presentationNotes';

            let presData = pres.getPresentationDataID(id);
            name = presData.name.get() ? presData.name.get() + this.oe.sharedInterface.getLocalizedStringEnc('presentation_notes_filename_notes') : this.oe.sharedInterface.getLocalizedStringEnc('presentation_notes_filename');

            FileSaver.saveAs(new Blob([new Uint8Array(buffer)]), name + '.xml');
            callback(result);
        }, bits);
    }
}

OEPresentationDataController.defaultProps = {
    moduleId:               '',
    id:                     -1,
    devFeatures:            false
};

OEPresentationDataController.propTypes = {
    moduleId:               PropTypes.string,
    id:                     PropTypes.number,
    devFeatures:            PropTypes.bool
};

export const OEPresentationPopover = OEPopover.coat(OEPresentationDataController, {}, {
    placement:              'right',
    buttonClassName:        'transparent-btn',
    headerSeparator:        true,
    titleId:                'presentation_data_view',
    controllerClassName:    ''
}, {
    controllerClassName:    PropTypes.string
});

//
export default withIsOpenState(OEPresentationPopover);